export const STREAM_URL = "https://s5.ssl-stream.com:2020/8046/stream";
export const STATION_NAME = "Napoli Lounge";
export const STATION_TAGLINE = "Suoni sofisticati dal cuore di Napoli";
